import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=41d4b86c&scoped=true&"
import script from "./Article.vue?vue&type=script&lang=js&"
export * from "./Article.vue?vue&type=script&lang=js&"
import style0 from "./Article.vue?vue&type=style&index=0&id=41d4b86c&prod&scoped=true&lang=css&"
import style1 from "./Article.vue?vue&type=style&index=1&id=41d4b86c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d4b86c",
  null
  
)

export default component.exports